const DEFAULT_RECOMMENDED_ADS_CONFIG = {
  minRecommendations: 3,
  maxRecommendations: 10,
  minResultsToShowRecommendations: 5,
  visitedAdSessionStorageKey: 'visitedAd'
}

export const RECOMMENDED_ADS = {
  default: {...DEFAULT_RECOMMENDED_ADS_CONFIG},
  adsList: {...DEFAULT_RECOMMENDED_ADS_CONFIG},
  userFavorites: {
    ...DEFAULT_RECOMMENDED_ADS_CONFIG,
    minResultsToShowRecommendations: 1
  },
  userFavoritesDeletedAd: {
    ...DEFAULT_RECOMMENDED_ADS_CONFIG,
    maxRecommendations: 6
  },
  recommendationsPage: {
    ...DEFAULT_RECOMMENDED_ADS_CONFIG,
    maxRecommendations: 12
  }
}
